/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 01.07.2016
 *
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { FormGroup } from 'external/react-bootstrap';
import { DraggableList, ValidationMessage } from 'plugin/liferay-widgets-react-web';

function MapConfigLayerOrdering({ onChange, logicalLayers = [], formValidation }) {

  return (
    <React.Fragment>
      <ValidationMessage formValidation={formValidation} propName="zIndexes"/>
      <FormGroup>
        <DraggableList
          DragItem={({ item }) => (
            <div className="list-item-name">
              {`${item.title} (${item.description || '---'})`}
            </div>
          )}
          list={logicalLayers}
          changeOrder={onChange}
          keyProp="uuid"
        />

      </FormGroup>
      <ValidationMessage formValidation={formValidation} propName="zIndexes"/>
    </React.Fragment>
  );

}

MapConfigLayerOrdering.propTypes = {
  logicalLayers: PropTypes.array,
  formValidation: PropTypes.object,
  onChange: PropTypes.func
};

export default MapConfigLayerOrdering;



// WEBPACK FOOTER //
// ./js/components/MapConfigLayerOrdering.jsx